module.exports = __webpack_public_path__ + "img/icon-email.b2a6500a.svg";